<template>
  <section class="dorm-module dorm-building-page">
    <!-- 左侧楼栋 -->
    <aside class="left-panel dorm-card">
      <div class="left-header">
        <div class="left-title-wrap">
          <span class="title">楼栋</span>
          <span class="count">{{ buildings.length }}</span>
        </div>
        <el-button type="primary" size="mini" icon="el-icon-plus" class="cursor-pointer" @click="openBuildingForm()">新增</el-button>
      </div>
      <div class="building-list" v-loading="loadingBuildings">
        <div
          v-for="item in buildings"
          :key="item.Id"
          :class="['building-item', isBuildingActive(item) ? 'is-active' : '']"
          @click="onSelectBuilding(item)"
        >
          <div class="building-main">
            <div class="building-text">
              <div class="building-name" :title="buildingTitleText(item)">{{ buildingDisplayName(item) }}</div>
              <div v-if="buildingDisplayCode(item)" class="building-code">编号 {{ buildingDisplayCode(item) }}</div>
            </div>
            <el-tag size="mini" :type="item.Gender === 1 ? 'danger' : 'info'" effect="plain">
              {{ item.Gender === 1 ? '女生' : '男生' }}
            </el-tag>
          </div>
          <div class="building-ops">
            <el-button type="text" size="mini" @click.stop="openBuildingForm(item)">编辑</el-button>
            <el-button type="text" size="mini" class="danger-text" @click.stop="removeBuilding(item)">删除</el-button>
          </div>
        </div>
        <div v-if="!loadingBuildings && buildings.length === 0" class="list-empty">暂无楼栋，请先新增</div>
      </div>
    </aside>

    <!-- 右侧 -->
    <section class="right-panel dorm-card">
      <div class="right-header">
        <div class="page-title">
          宿舍楼管理
          <span v-if="selectedBuilding" class="sub">{{ buildingTitleText(selectedBuilding) }}</span>
        </div>
        <div v-if="selectedBuilding" class="actions">
          <el-button size="mini" type="danger" plain @click="clearBuilding">清空整楼人员</el-button>
          <el-button size="mini" @click="floorsVisible = true">管理楼层</el-button>
          <el-button size="mini" type="primary" @click="openRoomForm()">新增房间</el-button>
        </div>
      </div>

      <div v-if="!selectedBuilding" class="empty-hint">
        <i class="el-icon-office-building"></i>
        <p>请选择左侧楼栋</p>
        <span>选中后可管理房间、床位与变动记录</span>
      </div>

      <template v-else>
        <el-tabs v-model="activeTab" @tab-click="onTabChange">
          <el-tab-pane label="房间管理" name="rooms" />
          <el-tab-pane label="变动记录" name="changelog" />
        </el-tabs>

        <div v-show="activeTab === 'rooms'" class="tab-body">
          <div class="toolbar-filter-bar">
            <el-form :inline="true" class="toolbar-filter-form">
              <div class="toolbar-filter-fields">
              <el-form-item label="楼层">
                <el-select v-model="filterFloorId" clearable placeholder="楼层" class="toolbar-field-w-sm" @change="onRoomFilterChange">
                  <el-option v-for="f in floors" :key="f.Id" :label="f.Description || ('第' + f.Number + '层')" :value="f.Id" />
                </el-select>
              </el-form-item>
              <el-form-item label="房间类型">
                <el-select v-model="filterRoomType" clearable placeholder="房间类型" class="toolbar-field-w-sm" @change="onRoomFilterChange">
                  <el-option label="学生房" :value="0" />
                  <el-option label="宿管房" :value="1" />
                  <el-option label="非居住" :value="2" />
                </el-select>
              </el-form-item>
              <el-form-item label="房号">
                <el-input v-model="filterQuery" clearable placeholder="搜索房号" class="toolbar-field-w-md" @keyup.enter.native="onRoomFilterChange" />
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="onRoomFilterChange">查询</el-button>
              </el-form-item>
              </div>
              <div class="toolbar-filter-actions">
                <el-button
                  size="small"
                  type="danger"
                  icon="el-icon-delete"
                  :disabled="!selectedRoomIds.length"
                  @click="batchRemoveRooms"
                >批量删除{{ selectedRoomIds.length ? `（${selectedRoomIds.length}）` : '' }}</el-button>
                <el-button size="small" @click="batchVisible = true">批量生成</el-button>
                <el-button size="small" icon="el-icon-document" @click="liveBatchVisible = true">批量导入/导出</el-button>
              </div>
            </el-form>
          </div>

          <div class="table-wrap">
            <el-table
              ref="roomTable"
              :data="rooms"
              v-loading="loadingRooms"
              border
              size="small"
              height="100%"
              class="room-table"
              row-key="Id"
              @selection-change="onRoomSelectionChange"
              @row-click="openBeds"
            >
              <el-table-column type="selection" width="46" align="center" :reserve-selection="false" />
              <el-table-column prop="RoomCode" label="房间编码" min-width="110" align="center" show-overflow-tooltip />
              <el-table-column prop="RoomName" label="房间名称" min-width="110" align="center" show-overflow-tooltip />
              <el-table-column prop="FloorsNumber" label="楼层" width="80" align="center" />
              <el-table-column prop="RoomType" label="类型" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag size="mini" :type="roomTypeTagType(scope.row.RoomType)" effect="plain">
                    {{ roomTypeText(scope.row.RoomType) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="入住" width="100" align="center">
                <template slot-scope="scope">{{ scope.row.AlreadyLiveCount }}/{{ scope.row.PeopleCount }}</template>
              </el-table-column>
              <el-table-column label="操作" width="200" align="center" fixed="right">
                <template slot-scope="scope">
                  <div class="table-op-pair">
                    <el-button type="text" class="table-op-link" size="mini" @click.stop="openBeds(scope.row)">床位</el-button>
                    <el-button type="text" class="table-op-link" size="mini" @click.stop="openRoomForm(scope.row)">编辑</el-button>
                    <el-button type="text" class="table-op-link table-op-link--danger" size="mini" @click.stop="removeRoom(scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-container">
            <el-pagination
              layout="total, prev, pager, next, jumper"
              :page-size="roomPageSize"
              :current-page.sync="roomPage"
              :total="roomTotal"
              @current-change="loadRooms"
            />
          </div>
        </div>

        <div v-show="activeTab === 'changelog'" class="tab-body">
          <div class="toolbar-filter-bar">
            <el-form :inline="true" class="toolbar-filter-form">
              <div class="toolbar-filter-fields">
              <el-form-item label="时间">
                <el-date-picker
                  v-model="logDateRange"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  class="toolbar-field-w-daterange"
                  @change="onLogFilterChange"
                />
              </el-form-item>
              <el-form-item label="变动类型">
                <el-select
                  v-model="logChangeType"
                  clearable
                  placeholder="变动类型"
                  class="toolbar-field-w-sm"
                  @change="onLogFilterChange"
                >
                  <el-option
                    v-for="opt in changeTypeOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="关键词">
                <el-input
                  v-model="logQuery"
                  clearable
                  placeholder="姓名 / 学号 / 操作人"
                  class="toolbar-field-w-md"
                  @keyup.enter.native="onLogFilterChange"
                  @clear="onLogFilterChange"
                />
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="onLogFilterChange">查询</el-button>
              </el-form-item>
              </div>
              <div class="toolbar-filter-actions">
                <el-button size="small" type="info" icon="el-icon-refresh-left" @click="resetLogFilter">重置</el-button>
              </div>
            </el-form>
          </div>
          <div class="table-wrap">
            <el-table :data="changeLogs" v-loading="loadingLogs" border size="small" height="100%">
              <el-table-column prop="ChangeTime" label="时间" width="160" />
              <el-table-column label="类型" width="110">
                <template slot-scope="scope">
                  {{ changeTypeText(scope.row.ChangeTypeName || scope.row.ChangeType) }}
                </template>
              </el-table-column>
              <el-table-column prop="PersonName" label="人员" width="100" />
              <el-table-column prop="PersonNo" label="学号/工号" width="110" />
              <el-table-column label="原位置" min-width="140" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatLoc(scope.row.SourceBuildingName, scope.row.SourceRoomName, scope.row.SourceBedNum) }}
                </template>
              </el-table-column>
              <el-table-column label="目标位置" min-width="140" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatLoc(scope.row.TargetBuildingName, scope.row.TargetRoomName, scope.row.TargetBedNum) }}
                </template>
              </el-table-column>
              <el-table-column prop="OperatorName" label="操作人" width="120" />
            </el-table>
          </div>
          <div class="pagination-container">
            <el-pagination
              layout="total, prev, pager, next, jumper"
              :page-size="logPageSize"
              :current-page.sync="logPage"
              :total="logTotal"
              @current-change="loadChangeLogs"
            />
          </div>
        </div>
      </template>
    </section>

    <!-- 楼栋表单 -->
    <el-dialog :title="buildingForm.Id ? '编辑楼栋' : '新增楼栋'" :visible.sync="buildingVisible" width="520px" :close-on-click-modal="false">
      <el-form :model="buildingForm" :rules="buildingRules" ref="buildingForm" label-width="100px" size="small">
        <el-form-item label="名称" prop="Name"><el-input v-model="buildingForm.Name" /></el-form-item>
        <el-form-item label="编号" prop="Code"><el-input v-model="buildingForm.Code" /></el-form-item>
        <el-form-item label="性别" prop="Gender">
          <el-radio-group v-model="buildingForm.Gender">
            <el-radio :label="0">男生宿舍</el-radio>
            <el-radio :label="1">女生宿舍</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="宿舍管理员" prop="HostelAdminIdList">
          <!-- 不折叠：尽量展示全部姓名，宽度不够时标签自动换行。最后修改：2026-09-14 -->
          <el-select
            v-model="buildingForm.HostelAdminIdList"
            multiple
            filterable
            clearable
            placeholder="请选择宿舍管理员（可多选）"
            class="hostel-admin-select"
            style="width: 100%"
            :loading="teacherLoading"
          >
            <el-option
              v-for="t in teacherOptions"
              :key="t.Id"
              :label="t.TeacherName"
              :value="String(t.Id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!buildingForm.Id" label="初始楼层" prop="FloorCount">
          <el-input-number v-model="buildingForm.FloorCount" :min="0" :max="50" />
          <div class="form-tip">仅创建楼层，房间请用「批量生成」或「新增房间」</div>
        </el-form-item>
        <el-form-item label="地址"><el-input v-model="buildingForm.Address" /></el-form-item>
        <el-form-item label="描述"><el-input v-model="buildingForm.Description" type="textarea" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="buildingVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitBuilding">保存</el-button>
      </div>
    </el-dialog>

    <!-- 楼层管理 -->
    <el-dialog title="楼层管理" :visible.sync="floorsVisible" width="560px" @open="onFloorsDialogOpen">
      <div class="floor-toolbar">
        <el-button size="mini" type="primary" @click="openFloorForm()">新增楼层</el-button>
        <el-button
          size="mini"
          type="danger"
          plain
          :disabled="!selectedFloorIds.length"
          @click="batchRemoveFloors"
        >批量删除{{ selectedFloorIds.length ? `（${selectedFloorIds.length}）` : '' }}</el-button>
      </div>
      <el-table
        ref="floorTable"
        :data="floors"
        size="small"
        border
        row-key="Id"
        @selection-change="onFloorSelectionChange"
      >
        <el-table-column type="selection" width="46" align="center" />
        <el-table-column prop="Number" label="楼层号" width="80" />
        <el-table-column prop="Description" label="描述" />
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openFloorForm(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" class="danger-text" @click="removeFloor(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="floorForm.Id ? '编辑楼层' : '新增楼层'" :visible.sync="floorFormVisible" width="400px" append-to-body>
      <el-form :model="floorForm" label-width="80px" size="small">
        <el-form-item label="楼层号"><el-input-number v-model="floorForm.Number" :min="1" /></el-form-item>
        <el-form-item label="描述"><el-input v-model="floorForm.Description" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="floorFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitFloor">保存</el-button>
      </div>
    </el-dialog>

    <!-- 房间表单 -->
    <el-dialog :title="roomForm.Id ? '编辑房间' : '新增房间'" :visible.sync="roomVisible" width="480px" :close-on-click-modal="false">
      <el-form :model="roomForm" :rules="roomRules" ref="roomForm" label-width="90px" size="small">
        <el-form-item label="楼层" prop="FloorsId">
          <el-select v-model="roomForm.FloorsId" style="width: 100%">
            <el-option v-for="f in floors" :key="f.Id" :label="f.Description || ('第' + f.Number + '层')" :value="f.Id" />
          </el-select>
        </el-form-item>
        <el-form-item label="房间序号" prop="Number"><el-input-number v-model="roomForm.Number" :min="1" /></el-form-item>
        <el-form-item label="房间编码"><el-input v-model="roomForm.RoomCode" placeholder="默认 层号+序号两位" /></el-form-item>
        <el-form-item label="房间名称"><el-input v-model="roomForm.RoomName" /></el-form-item>
        <el-form-item label="房间类型">
          <el-select v-model="roomForm.RoomType" style="width: 100%">
            <el-option label="学生房" :value="0" />
            <el-option label="宿管房" :value="1" />
            <el-option label="非居住" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="roomForm.RoomType !== 2" label="床位容量" prop="PeopleCount">
          <el-input-number v-model="roomForm.PeopleCount" :min="0" :max="20" />
        </el-form-item>
        <el-form-item label="描述"><el-input v-model="roomForm.Description" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="roomVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitRoom">保存</el-button>
      </div>
    </el-dialog>

    <!-- 批量生成 -->
    <el-dialog
      title="楼层差异化批量生成"
      :visible.sync="batchVisible"
      width="780px"
      custom-class="batch-gen-dialog"
      :close-on-click-modal="false"
      @open="initBatchConfigs"
    >
      <el-table :data="batchConfigs" size="small" border class="batch-gen-table">
        <el-table-column prop="FloorNum" label="楼层" width="72" align="center" />
        <el-table-column label="起始房号" width="160" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.StartRoomNum" :min="1" :controls="true" size="mini" class="batch-num" />
          </template>
        </el-table-column>
        <el-table-column label="房间数" width="160" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.RoomCount" :min="1" :controls="true" size="mini" class="batch-num" />
          </template>
        </el-table-column>
        <el-table-column label="每间床位" width="160" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.Capacity" :min="0" :controls="true" size="mini" class="batch-num" />
          </template>
        </el-table-column>
        <el-table-column label="预览" min-width="160" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.FloorNum }}{{ pad2(scope.row.StartRoomNum) }} ~
            {{ scope.row.FloorNum }}{{ pad2(scope.row.StartRoomNum + scope.row.RoomCount - 1) }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="batch-gen-footer">
        <el-button @click="batchVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitBatch">开始生成</el-button>
      </div>
    </el-dialog>

    <dorm-bed-manager-dialog
      :visible.sync="bedVisible"
      :building-id="selectedBuilding && selectedBuilding.Id"
      :building-gender="selectedBuilding ? selectedBuilding.Gender : 0"
      :room-id="currentRoomId"
      :school-department-id="schoolDepartmentId"
      @changed="loadRooms"
    />

    <dorm-live-batch-console-dialog
      :visible.sync="liveBatchVisible"
      :school-department-id="schoolDepartmentId"
      :building-id="selectedBuilding && selectedBuilding.Id"
      :building-name="selectedBuilding ? buildingTitleText(selectedBuilding) : ''"
      @changed="onLiveBatchChanged"
    />
  </section>
</template>

<script>
import {
  getBuildingsListPage, addBuildings, editBuildings, removeBuildings,
  batchUnbindLiveData, batchAddRoomsCustom, getDormChangeRecords, batchDeleteRooms
} from '../../api/modules/dormitory'
import {
  getfloorsListPage, addfloors, editfloors, removefloors, batchDeleteFloors,
  getroomsListPage, addrooms, editrooms, removerooms
} from '../../api/modules/misc'
import { getTeacherMasterList } from '../../api/modules/personnel'
import DormBedManagerDialog from './components/DormBedManagerDialog.vue'
import DormLiveBatchConsoleDialog from './components/DormLiveBatchConsoleDialog.vue'
import '../../styles/dorm-module.css'

export default {
  name: 'Buildings',
  components: { DormBedManagerDialog, DormLiveBatchConsoleDialog },
  data() {
    return {
      buildings: [],
      loadingBuildings: false,
      selectedBuilding: null,
      activeTab: 'rooms',
      floors: [],
      rooms: [],
      loadingRooms: false,
      roomPage: 1,
      roomPageSize: 10,
      roomTotal: 0,
      filterFloorId: null,
      filterRoomType: null,
      filterQuery: '',
      selectedRoomIds: [],
      selectedFloorIds: [],
      liveBatchVisible: false,
      changeLogs: [],
      loadingLogs: false,
      logPage: 1,
      logPageSize: 20,
      logTotal: 0,
      logDateRange: [],
      logChangeType: '',
      logQuery: '',
      changeTypeOptions: [
        { value: 'StudentCheckIn', label: '学生入住' },
        { value: 'TeacherCheckIn', label: '教师入住' },
        { value: 'CheckOut', label: '退宿' },
        { value: 'ChangeBed', label: '调宿' },
        { value: 'SwapBed', label: '交换床位' },
        { value: 'BatchImport', label: '批量导入' },
        { value: 'ForceClear', label: '强制清空' }
      ],
      buildingVisible: false,
      buildingForm: {
        Id: 0,
        Name: '',
        Code: '',
        Gender: 0,
        FloorCount: 1,
        Address: '',
        Description: '',
        HostelAdminIdList: []
      },
      buildingRules: {
        Name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        Code: [{ required: true, message: '请输入编号', trigger: 'blur' }]
      },
      teacherOptions: [],
      teacherLoading: false,
      floorsVisible: false,
      floorFormVisible: false,
      floorForm: { Id: 0, Number: 1, Description: '' },
      roomVisible: false,
      roomForm: { Id: 0, FloorsId: null, Number: 1, RoomCode: '', RoomName: '', RoomType: 0, PeopleCount: 4, Description: '' },
      roomRules: {
        FloorsId: [{ required: true, message: '请选择楼层', trigger: 'change' }],
        Number: [{ required: true, message: '请输入序号', trigger: 'blur' }]
      },
      batchVisible: false,
      batchConfigs: [],
      bedVisible: false,
      currentRoomId: 0,
      saving: false
    }
  },
  computed: {
    schoolDepartmentId() {
      // 勿用 Number()：雪花 Id 会丢精度，导致组织树落到「总平台」
      const id = this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId') || ''
      return id || 0
    }
  },
  watch: {
    schoolDepartmentId: {
      immediate: true,
      handler() {
        this.selectedBuilding = null
        this.loadBuildings()
      }
    }
  },
  methods: {
    pad2(n) {
      const num = Number(n) || 0
      return num < 10 ? '0' + num : String(num)
    },
    changeTypeText(type) {
      const map = {
        StudentCheckIn: '学生入住',
        TeacherCheckIn: '教师入住',
        CheckOut: '退宿',
        ChangeBed: '调宿',
        SwapBed: '交换床位',
        BatchImport: '批量导入',
        ForceClear: '强制清空'
      }
      // 已是中文（ChangeTypeName）则直接展示
      if (type && !map[type] && /[\u4e00-\u9fa5]/.test(type)) return type
      return map[type] || type || '-'
    },
    roomTypeText(t) {
      if (t === 1) return '宿管房'
      if (t === 2) return '非居住'
      return '学生房'
    },
    roomTypeTagType(t) {
      if (t === 1) return 'warning'
      if (t === 2) return 'info'
      return 'success'
    },
    formatLoc(building, room, bed) {
      const parts = [building, room, bed != null ? (bed + '床') : ''].filter(Boolean)
      return parts.join(' / ') || '-'
    },
    /** 楼栋主标题：名称优先，无名称则用编号 */
    buildingDisplayName(item) {
      if (!item) return ''
      const name = String(item.Name || '').trim()
      const code = String(item.Code || '').trim()
      return name || code || '未命名楼栋'
    },
    /** 编号副标题：与名称不同时展示 */
    buildingDisplayCode(item) {
      if (!item) return ''
      const name = String(item.Name || '').trim()
      const code = String(item.Code || '').trim()
      if (!code || code === name) return ''
      return code
    },
    /** 完整楼栋标识（右侧标题、tooltip） */
    buildingTitleText(item) {
      if (!item) return ''
      const name = this.buildingDisplayName(item)
      const code = this.buildingDisplayCode(item)
      return code ? `${name} · ${code}` : name
    },
    isBuildingActive(item) {
      if (!this.selectedBuilding || !item) return false
      return String(this.selectedBuilding.Id) === String(item.Id)
    },
    async loadBuildings() {
      if (!this.schoolDepartmentId) {
        this.buildings = []
        this.selectedBuilding = null
        this.$message.warning('请先在顶栏选择学校')
        return
      }
      this.loadingBuildings = true
      try {
        const res = await getBuildingsListPage({
          page: 1,
          intPageSize: 500,
          departmentId: this.schoolDepartmentId
        })
        if (res.data && res.data.success) {
          this.buildings = (res.data.response && res.data.response.data) || []
        }
        // 进入页/切换学校：无选中时默认第一栋；已选中则尽量保持
        const list = this.buildings || []
        if (!list.length) {
          this.selectedBuilding = null
          return
        }
        const keepId = this.selectedBuilding && this.selectedBuilding.Id
        const keep = keepId != null ? list.find(b => String(b.Id) === String(keepId)) : null
        if (keep) {
          this.selectedBuilding = keep
        } else {
          await this.onSelectBuilding(list[0])
        }
      } finally {
        this.loadingBuildings = false
      }
    },
    async onSelectBuilding(row) {
      if (!row) return
      // 同楼栋重复点击不重复请求
      if (this.isBuildingActive(row)) return
      this.selectedBuilding = row
      this.activeTab = 'rooms'
      this.filterFloorId = null
      this.filterRoomType = null
      this.filterQuery = ''
      this.roomPage = 1
      this.roomTotal = 0
      this.clearRoomSelection()
      await this.loadFloors()
      await this.loadRooms()
    },
    async loadFloors() {
      if (!this.selectedBuilding) return
      const res = await getfloorsListPage({ page: 1, intPageSize: 200, buildingId: this.selectedBuilding.Id })
      if (res.data && res.data.success) {
        this.floors = (res.data.response && res.data.response.data) || []
      }
    },
    onRoomFilterChange() {
      this.roomPage = 1
      this.clearRoomSelection()
      this.loadRooms()
    },
    clearRoomSelection() {
      this.selectedRoomIds = []
      if (this.$refs.roomTable) this.$refs.roomTable.clearSelection()
    },
    onRoomSelectionChange(rows) {
      this.selectedRoomIds = (rows || []).map(r => r.Id).filter(Boolean)
    },
    onFloorSelectionChange(rows) {
      this.selectedFloorIds = (rows || []).map(r => r.Id).filter(Boolean)
    },
    async onFloorsDialogOpen() {
      this.selectedFloorIds = []
      await this.loadFloors()
      this.$nextTick(() => {
        if (this.$refs.floorTable) this.$refs.floorTable.clearSelection()
      })
    },
    async loadRooms() {
      if (!this.selectedBuilding) return
      this.loadingRooms = true
      try {
        const res = await getroomsListPage({
          page: this.roomPage || 1,
          intPageSize: this.roomPageSize,
          buildingId: this.selectedBuilding.Id,
          floorId: this.filterFloorId || '',
          roomType: this.filterRoomType === null || this.filterRoomType === '' ? '' : this.filterRoomType,
          query: this.filterQuery || ''
        })
        if (res.data && res.data.success) {
          const resp = res.data.response || {}
          this.rooms = resp.data || []
          this.roomTotal = resp.dataCount || 0
          this.selectedRoomIds = []
          this.$nextTick(() => {
            if (this.$refs.roomTable) this.$refs.roomTable.clearSelection()
          })
          // 删除后当前页空了，回退一页
          if (this.rooms.length === 0 && this.roomPage > 1 && this.roomTotal > 0) {
            this.roomPage -= 1
            await this.loadRooms()
          }
        }
      } finally {
        this.loadingRooms = false
      }
    },
    onTabChange() {
      if (this.activeTab === 'changelog') this.loadChangeLogs()
    },
    onLiveBatchChanged() {
      if (this.selectedBuilding) this.loadRooms()
    },
    onLogFilterChange() {
      this.logPage = 1
      this.loadChangeLogs()
    },
    resetLogFilter() {
      this.logDateRange = []
      this.logChangeType = ''
      this.logQuery = ''
      this.onLogFilterChange()
    },
    async loadChangeLogs() {
      if (!this.selectedBuilding) return
      this.loadingLogs = true
      try {
        const range = this.logDateRange || []
        const res = await getDormChangeRecords({
          page: this.logPage,
          intPageSize: this.logPageSize,
          departmentId: this.schoolDepartmentId,
          buildingId: this.selectedBuilding.Id,
          changeType: this.logChangeType || '',
          query: (this.logQuery || '').trim(),
          startDate: range[0] || '',
          endDate: range[1] || ''
        })
        if (res.data && res.data.success) {
          this.changeLogs = (res.data.response && res.data.response.data) || []
          this.logTotal = (res.data.response && res.data.response.dataCount) || 0
        }
      } finally {
        this.loadingLogs = false
      }
    },
    openBuildingForm(row) {
      if (row) {
        this.buildingForm = {
          Id: row.Id,
          Name: row.Name,
          Code: row.Code,
          Gender: row.Gender || 0,
          FloorCount: row.FloorCount || row.FloorsNumber || 0,
          Address: row.Address || '',
          Description: row.Description || '',
          HostelAdminIdList: this.parseAdminIds(row.HostelAdminIds)
        }
      } else {
        this.buildingForm = {
          Id: 0,
          Name: '',
          Code: '',
          Gender: 0,
          FloorCount: 1,
          Address: '',
          Description: '',
          HostelAdminIdList: []
        }
      }
      this.buildingVisible = true
      this.loadTeacherOptions()
    },
    parseAdminIds(raw) {
      if (!raw) return []
      return String(raw).split(',').map(s => s.trim()).filter(Boolean).map(String)
    },
    async loadTeacherOptions() {
      if (!this.schoolDepartmentId) {
        this.teacherOptions = []
        return
      }
      this.teacherLoading = true
      try {
        const res = await getTeacherMasterList({ departmentId: this.schoolDepartmentId })
        if (res.data && res.data.success) {
          const raw = res.data.response
          this.teacherOptions = Array.isArray(raw) ? raw : (raw && raw.data) || []
        } else {
          this.teacherOptions = []
        }
      } catch (e) {
        this.teacherOptions = []
      } finally {
        this.teacherLoading = false
      }
    },
    submitBuilding() {
      this.$refs.buildingForm.validate(async (ok) => {
        if (!ok) return
        if (!this.schoolDepartmentId) return this.$message.warning('请先选择学校')
        this.saving = true
        try {
          const adminIds = (this.buildingForm.HostelAdminIdList || []).map(String).filter(Boolean)
          const payload = {
            ...this.buildingForm,
            DepartmentId: this.schoolDepartmentId,
            HostelAdminIds: adminIds.join(',')
          }
          delete payload.HostelAdminIdList
          const res = this.buildingForm.Id
            ? await editBuildings(payload)
            : await addBuildings(payload)
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || '保存成功')
            this.buildingVisible = false
            await this.loadBuildings()
          } else {
            this.$message.error((res.data && res.data.msg) || '保存失败')
          }
        } finally {
          this.saving = false
        }
      })
    },
    async removeBuilding(row) {
      await this.$confirm(`确认删除楼栋「${this.buildingTitleText(row)}」？`, '提示', { type: 'warning' })
      const res = await removeBuildings({ id: row.Id })
      if (res.data && res.data.success) {
        this.$message.success('删除成功')
        if (this.selectedBuilding && this.selectedBuilding.Id === row.Id) this.selectedBuilding = null
        this.loadBuildings()
      } else {
        this.$message.error((res.data && res.data.msg) || '删除失败')
      }
    },
    async clearBuilding() {
      if (!this.selectedBuilding) return
      const buildingLabel = this.buildingTitleText(this.selectedBuilding)
      try {
        await this.$confirm(
          `将清空【${buildingLabel}】所有入住人员，是否继续？`,
          '警告',
          { type: 'warning' }
        )
        const res = await batchUnbindLiveData({ Id: String(this.selectedBuilding.Id) })
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '已清空')
          this.loadRooms()
          if (this.activeTab === 'changelog') this.loadChangeLogs()
        } else {
          this.$message.error((res.data && res.data.msg) || (res && res.message) || '操作失败')
        }
      } catch (e) {
        const errMsg = (e && (e.message || e.bizMessage)) || ''
        if (errMsg.indexOf('timeout') > -1 || (e && e.code === 'ECONNABORTED')) {
          this.$message.warning('操作耗时较长，请刷新页面确认是否已清空完成')
        } else if (e !== 'cancel') {
          this.$message.error(errMsg || '操作失败')
        }
      }
    },
    openFloorForm(row) {
      this.floorForm = row
        ? { Id: row.Id, Number: row.Number, Description: row.Description }
        : { Id: 0, Number: (this.floors.length || 0) + 1, Description: '' }
      this.floorFormVisible = true
    },
    async submitFloor() {
      const payload = {
        ...this.floorForm,
        BuildingId: this.selectedBuilding.Id,
        Description: this.floorForm.Description || ('第' + this.floorForm.Number + '层')
      }
      const res = this.floorForm.Id ? await editfloors(payload) : await addfloors(payload)
      if (res.data && res.data.success) {
        this.$message.success('保存成功')
        this.floorFormVisible = false
        this.loadFloors()
      } else {
        this.$message.error((res.data && res.data.msg) || '保存失败')
      }
    },
    async removeFloor(row) {
      await this.$confirm('确认删除该楼层？有房间时将拒绝', '提示', { type: 'warning' })
      const res = await removefloors({ id: row.Id })
      if (res.data && res.data.success) {
        this.$message.success('删除成功')
        this.selectedFloorIds = []
        this.loadFloors()
      } else {
        this.$message.error((res.data && res.data.msg) || '删除失败')
      }
    },
    async batchRemoveFloors() {
      if (!this.selectedFloorIds.length) return
      try {
        await this.$confirm(
          `确认删除选中的 ${this.selectedFloorIds.length} 个楼层？仍有房间的楼层将整批拒绝删除`,
          '批量删除楼层',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      const res = await batchDeleteFloors(this.selectedFloorIds)
      if (res.data && res.data.success) {
        this.$message.success(res.data.msg || '删除成功')
        this.selectedFloorIds = []
        if (this.$refs.floorTable) this.$refs.floorTable.clearSelection()
        await this.loadFloors()
        this.loadRooms()
      } else {
        this.$message.error((res.data && res.data.msg) || '删除失败')
      }
    },
    openRoomForm(row) {
      if (!this.floors.length) return this.$message.warning('请先创建楼层')
      if (row) {
        this.roomForm = {
          Id: row.Id,
          FloorsId: row.FloorsId,
          Number: row.Number,
          RoomCode: row.RoomCode || '',
          RoomName: row.RoomName || '',
          RoomType: row.RoomType || 0,
          PeopleCount: row.PeopleCount || 0,
          Description: row.Description || '',
          BuildingId: row.BuildingId,
          Gender: row.Gender
        }
      } else {
        this.roomForm = {
          Id: 0,
          FloorsId: this.filterFloorId || this.floors[0].Id,
          Number: 1,
          RoomCode: '',
          RoomName: '',
          RoomType: 0,
          PeopleCount: 4,
          Description: '',
          BuildingId: this.selectedBuilding.Id,
          Gender: this.selectedBuilding.Gender || 0
        }
      }
      this.roomVisible = true
    },
    submitRoom() {
      this.$refs.roomForm.validate(async (ok) => {
        if (!ok) return
        this.saving = true
        try {
          const payload = {
            ...this.roomForm,
            BuildingId: this.selectedBuilding.Id,
            Gender: this.selectedBuilding.Gender || 0,
            PeopleCount: this.roomForm.RoomType === 2 ? 0 : this.roomForm.PeopleCount
          }
          const res = this.roomForm.Id ? await editrooms(payload) : await addrooms(payload)
          if (res.data && res.data.success) {
            this.$message.success('保存成功')
            this.roomVisible = false
            this.loadRooms()
          } else {
            this.$message.error((res.data && res.data.msg) || '保存失败')
          }
        } finally {
          this.saving = false
        }
      })
    },
    async removeRoom(row) {
      const roomLabel = row.RoomCode || row.RoomName || row.Number
      const liveCount = Number(row.AlreadyLiveCount) || 0
      let force = false
      try {
        if (liveCount > 0) {
          await this.$confirm(
            `警告：房间【${roomLabel}】当前仍有 ${liveCount} 人入住！直接删除会强制将这些人员退宿并清除床位分配关系！极其确定要继续删除吗？`,
            '警告',
            { type: 'warning', confirmButtonText: '确定删除', cancelButtonText: '取消' }
          )
          force = true
        } else {
          await this.$confirm(`确认删除房间「${roomLabel}」？`, '提示', { type: 'warning' })
        }
      } catch (e) {
        return
      }
      const res = await removerooms({ id: row.Id, force })
      if (res.data && res.data.success) {
        this.$message.success(res.data.msg || '删除成功')
        this.clearRoomSelection()
        this.loadRooms()
      } else {
        this.$message.error((res.data && res.data.msg) || '删除失败')
      }
    },
    async batchRemoveRooms() {
      if (!this.selectedRoomIds.length) return
      const idSet = new Set(this.selectedRoomIds.map(id => String(id)))
      const selectedRows = (this.rooms || []).filter(r => idSet.has(String(r.Id)))
      const liveCount = selectedRows.reduce((sum, r) => sum + (Number(r.AlreadyLiveCount) || 0), 0)
      let force = false
      try {
        if (liveCount > 0) {
          await this.$confirm(
            `警告：所选 ${this.selectedRoomIds.length} 间房间合计仍有 ${liveCount} 人入住！直接删除会强制将这些人员退宿并清除床位分配关系！极其确定要继续删除吗？`,
            '警告',
            { type: 'warning', confirmButtonText: '确定删除', cancelButtonText: '取消' }
          )
          force = true
        } else {
          await this.$confirm(
            `确认删除选中的 ${this.selectedRoomIds.length} 间房间？`,
            '批量删除房间',
            { type: 'warning' }
          )
        }
      } catch (e) {
        return
      }
      const res = await batchDeleteRooms(this.selectedRoomIds, force)
      if (res.data && res.data.success) {
        this.$message.success(res.data.msg || '删除成功')
        this.clearRoomSelection()
        this.loadRooms()
      } else {
        this.$message.error((res.data && res.data.msg) || '删除失败')
      }
    },
    openBeds(row, column) {
      if (!row || !row.Id) return
      if (column && column.type === 'selection') return
      if (row.RoomType === 2) return this.$message.info('非居住房无床位')
      // 已打开时再点：先关再开，避免 visible 不变导致无响应
      const roomId = row.Id
      if (this.bedVisible && String(this.currentRoomId) === String(roomId)) {
        return
      }
      if (this.bedVisible) {
        this.bedVisible = false
        this.$nextTick(() => {
          this.currentRoomId = roomId
          this.bedVisible = true
        })
        return
      }
      this.currentRoomId = roomId
      this.bedVisible = true
    },
    initBatchConfigs() {
      const nums = this.floors.length
        ? this.floors.map(f => f.Number).sort((a, b) => a - b)
        : [1]
      this.batchConfigs = nums.map(n => ({
        FloorNum: n,
        StartRoomNum: 1,
        RoomCount: 6,
        Capacity: 4
      }))
    },
    async submitBatch() {
      if (!this.selectedBuilding) return
      this.saving = true
      try {
        const res = await batchAddRoomsCustom({
          BuildingId: this.selectedBuilding.Id,
          Configs: this.batchConfigs
        })
        if (res.data && res.data.success) {
          const r = res.data.response || {}
          this.$message.success(`创建 ${r.CreatedCount || 0}，跳过 ${r.SkippedCount || 0}`)
          this.batchVisible = false
          await this.loadFloors()
          await this.loadRooms()
        } else {
          this.$message.error((res.data && res.data.msg) || '生成失败')
        }
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.dorm-building-page {
  display: flex;
  /* 填满 content-az，禁止再用 100vh 顶破外框造成空白可滚 */
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
  gap: 20px;
  padding: 24px;
  background: #f4f7fc;
}
.left-panel {
  width: 300px;
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px !important;
}
.right-panel {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 14px;
  overflow: hidden;
  border-radius: 12px !important;
}
.left-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 14px 12px;
  border-bottom: 1px solid #e2e8f0;
}
.left-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.left-header .title {
  font-weight: 700;
  font-size: 15px;
  color: #134e4a;
}
.left-header .count {
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: #ccfbf1;
  color: #0f766e;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.building-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}
.building-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  margin-bottom: 6px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: #f8fafc;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}
.building-item:hover {
  background: #f0fdfa;
  border-color: #99f6e4;
}
.building-item.is-active {
  background: #ecfeff;
  border-color: #2dd4bf;
  box-shadow: 0 0 0 1px rgba(13, 148, 136, 0.12);
}
.building-main {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.building-text {
  min-width: 0;
  flex: 1;
}
.building-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.building-code {
  margin-top: 2px;
  font-size: 12px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.building-ops {
  display: inline-flex;
  align-self: flex-start;
  gap: 2px;
}
.list-empty {
  text-align: center;
  color: #94a3b8;
  padding: 40px 12px;
  font-size: 13px;
}
.right-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}
.page-title {
  font-size: 17px;
  font-weight: 700;
  color: #134e4a;
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.page-title .sub {
  font-size: 14px;
  font-weight: 600;
  color: #0d9488;
}
.actions { display: flex; gap: 6px; flex-wrap: wrap; }
.empty-hint {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #64748b;
  text-align: center;
  gap: 6px;
}
.empty-hint i {
  font-size: 42px;
  color: #5eead4;
  margin-bottom: 8px;
}
.empty-hint p {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #334155;
}
.empty-hint span {
  font-size: 13px;
  color: #94a3b8;
}
.tab-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.floor-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.table-wrap {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.room-table {
  width: 100% !important;
}
/* 分页容器：走全局 pagination-override 的右对齐。最后修改：2026-09-14 */
.pagination-container {
  flex-shrink: 0;
}
.form-tip {
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 4px;
}
.cursor-pointer {
  cursor: pointer;
}
/* 宿舍管理员多选：标签换行展示，避免只剩「+N」。最后修改：2026-09-14 */
.hostel-admin-select >>> .el-select__tags {
  max-width: 100%;
  white-space: normal;
}
.hostel-admin-select >>> .el-select__tags > span {
  display: inline-flex;
  flex-wrap: wrap;
  max-width: 100%;
}
</style>

<style>
.batch-gen-dialog .el-dialog__body {
  padding-top: 12px;
}
.batch-gen-table .el-table__body .cell {
  overflow: visible;
  padding: 8px 6px;
}
.batch-gen-table .batch-num {
  width: 132px;
}
.batch-gen-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.batch-gen-footer .el-button + .el-button {
  margin-left: 0;
}
</style>
